<template>
  <div class="-ml-6 w-52 shrink-0 border-r border-main">
    <RouterLink v-for="item in props.sidebarItems" :key="item.label" v-slot="{ isActive }" :to="item.route" class="relative block p-4">
      <span class="txt-label-s-semibold uppercase" :class="isActive ? 'text-main' : 'text-subtle'">
        {{ item.label }}
      </span>
    </RouterLink>
  </div>
</template>

<script lang="ts">
import { type RouteLocationNamedRaw } from 'vue-router'

export type SidebarItem = {
  label: string
  route: RouteLocationNamedRaw
}
</script>

<script setup lang="ts">
const props = defineProps<{
  sidebarItems: SidebarItem[]
}>()
</script>

<style scoped>
@reference '@ramp106/omrjs-config-tailwind/styles/index.css';

.router-link-active::before {
  content: '';
  @apply absolute top-3 bottom-3 left-0 w-1 rounded-full;
  background-color: var(--border-color-selected);
}
</style>
